import { useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useMediaQuery } from "@mui/material";

import usePlatform from "./usePlatform";

const useLayoutData = () => {
  const location = useLocation();
  const mobileNavHeight = useRef(46);

  const { isMobile } = usePlatform();

  const isMediaMin2000 = useMediaQuery("(max-width:1200px)");

  const showMobileNav = useMemo(
    () => isMediaMin2000 && ![""].includes(location.pathname),
    [location, isMediaMin2000]
  );

  const toolbarHeight = useMemo(() => {
    const defaultToolbarHeight = isMobile ? 56 : 64;

    return defaultToolbarHeight + (showMobileNav ? mobileNavHeight.current : 0);
  }, [showMobileNav, isMobile]);

  return {
    toolbarHeight,
    contentHeight: window.innerHeight - toolbarHeight,
    footerHeight: 112,
    mobileNavHeight: mobileNavHeight.current,
    showMobileNav,
  };
};

export default useLayoutData;
